import React from 'react'
import styled, { x } from '@xstyled/styled-components'
import { Link } from 'react-router-dom'

const CardWrapper = styled.article`
  border-radius: 5px;
  overflow: hidden;
  background: #041615;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
  }
`

export function BlogCard({ frontmatter }) {
  const { title, slug, date, description } = frontmatter

  const formattedDate = new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })

  return (
    <CardWrapper>
      <Link to={`/blog/${slug}`} style={{ textDecoration: 'none' }}>
        <x.div p="40px">
          <x.time
            display="block"
            fontSize="13px"
            color="lightGreen"
            mb="15px"
            lineHeight="100%">
            {formattedDate}
          </x.time>
          <x.h3
            fontSize="20px"
            fontWeight="500"
            color="lime"
            mb="20px"
            lineHeight="130%">
            {title}
          </x.h3>
          <x.p fontSize="14px" color="lime" opacity="0.7" lineHeight="200%">
            {description}
          </x.p>
        </x.div>
      </Link>
    </CardWrapper>
  )
}
